import { render, staticRenderFns } from "./feedbackTrainee.vue?vue&type=template&id=7f35cd03&scoped=true"
import script from "./feedbackTrainee.vue?vue&type=script&lang=js"
export * from "./feedbackTrainee.vue?vue&type=script&lang=js"
import style0 from "./feedbackTrainee.vue?vue&type=style&index=0&id=7f35cd03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f35cd03",
  null
  
)

export default component.exports